import { ContractNegotiationConcept } from '../models/Entities/Contracts/ContractNegotiationConcept';
import { NewContractNegotiationConcept } from '../models/Entities/Contracts/NewContractNegotiationConcept';
import { IResult } from '../models/HttpResult';
import * as Functions from '../functions/common';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/';

const GetRequestConfig = (token: string, method?: string, body?: unknown): RequestInit => ({
  method,
  body: body !== undefined ? JSON.stringify(body) : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  },
});

const HandleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    throw response;
  }

  const data = (await response.json()) as IResult<T>;
  return data.data;
};

const HandleError = async (error: any) => {
  const body = await error.text();
  throw Functions.HttpErrorHandler(body, error);
};

export const GetContractNegotiationConcepts = async (contractNegotiationId: string, token: string): Promise<ContractNegotiationConcept[]> => {
  const requestUrl = BaseURL + 'negotiations/' + contractNegotiationId + '/concepts/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiationConcept[]>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const GetContractNegotiationConceptById = async (id: string, token: string): Promise<ContractNegotiationConcept> => {
  const requestUrl = BaseURL + 'negotiations/concepts/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token))
      .then((response) => HandleResponse<ContractNegotiationConcept>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const CreateContractNegotiationConcept = async (contractNegotiationConcept: NewContractNegotiationConcept, token: string): Promise<ContractNegotiationConcept> => {
  const requestUrl = BaseURL + 'negotiations/concepts/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'POST', contractNegotiationConcept))
      .then((response) => HandleResponse<ContractNegotiationConcept>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const UpdateContractNegotiationConcept = async (contractNegotiationConcept: ContractNegotiationConcept, token: string): Promise<ContractNegotiationConcept> => {
  const requestUrl = BaseURL + 'negotiations/concepts/';

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'PUT', contractNegotiationConcept))
      .then((response) => HandleResponse<ContractNegotiationConcept>(response))
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};

export const DeleteContractNegotiationConcept = async (id: string, token: string): Promise<string> => {
  const requestUrl = BaseURL + 'negotiations/concepts/' + id;

  try {
    return await fetch(requestUrl, GetRequestConfig(token, 'DELETE'))
      .then((response) => {
        if (!response.ok) {
          throw response;
        }

        return id;
      })
      .catch(HandleError);
  } catch (error: any) {
    throw error;
  }
};